/* React */
import React from "react";

/* Ionic */
import { IonIcon } from "@ionic/react";
import { chevronDown, settings } from "ionicons/icons";

/* Components */
import PrimaryFabButton from "src/components/shared/buttons/primary-fab-button/PrimaryFabButton";

/* Stylesheet */
import styles from "./OptionsLabel.module.scss";

/* Interfaces */
interface OptionsLabelProps {
  onClick: () => void;
}

const OptionsLabel: React.FC<OptionsLabelProps> = ({
  onClick,
}) => {
  return (
    <div className={styles.options_label}>
      <div className={styles.label_container}>
        <IonIcon className={styles.icon} icon={settings} />
        <div className={styles.label}>Options</div>
      </div>
      <PrimaryFabButton
        className={"transparent small"}
        ariaLabel={"Options toggle"}
        icon={chevronDown}
        onClick={onClick}
      />
    </div>
  );
};

export default OptionsLabel;
